import { FunctionComponent } from 'react';
import { Modal, Image } from 'react-bootstrap';
import cn from 'classnames';
import styles from "./PromoteToSponsoredUser.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import { IFieldTheme } from '../../../../../component/common/FormField/FormField';
import { ASSESTS } from '../../../../../constant/assest';
import FormTextArea from '../../../../../component/common/FormField/FormTextArea';
import FormCheckbox from '../../../../../component/common/FormField/FormCheckbox';
import UserSelect from '../../../../../component/common/UserSelect/UserSelect';

interface IProps {
    showModal: boolean;
    onClose: () => void;
    className?: string;
};

const PromoteToSponsoredUser: FunctionComponent<IProps> = ({ showModal, onClose, className }) => {
    return (
        <Modal
            show={showModal}
            className={cn(styles.addModal, className)}
            dialogClassName={styles.addModalDialog}
            contentClassName={styles.addModalContent}
            centered={true}
        >
            <CustomButton
                className={styles.modalCloseBtn}
                btnType={ButtonType.IMAGE}
                onClick={onClose}
            >
                <Image src={ASSESTS.CLOSEPOPUP} alt="Close" />
            </CustomButton>
            <Modal.Header bsPrefix={styles.header}>
                <Modal.Title bsPrefix={styles.title} as={'div'}>Promote to sponsored user</Modal.Title>
                <Modal.Title bsPrefix={styles.summary} as={'div'}>Select an existing user and add their promotional content to make them a sponsored user.</Modal.Title>
            </Modal.Header>
            <Modal.Body bsPrefix={styles.body}>
                <UserSelect 
                    userList={[
                        { value: "michael", image: ASSESTS.USERPROFILE, label: "Michael Johnson", email: "michael.johnson@email.com" },
                        { value: "sophia", image: "", label: "Sophia Lee", email: "sophia.lee@email.com" },
                        { value: "daniel", image: "", label: "Daniel Martinez", email: "daniel.martinez@email.com" },
                        { value: "emma", image: ASSESTS.USERPROFILE, label: "Emma Wilson", email: "emma.wilson@email.com" },
                        { value: "james", image: "", label: "James Anderson", email: "james.anderson@email.com" },
                        { value: "olivia", image: "", label: "Olivia Garcia", email: "olivia.garcia@email.com" },
                        { value: "ethan", image: ASSESTS.USERPROFILE, label: "Ethan Taylor", email: "ethan.taylor@email.com" },
                        { value: "ava", image: "", label: "Ava Thomas", email: "ava.thomas@email.com" },
                        { value: "william", image: "", label: "William Harris", email: "william.harris@email.com" },
                        { value: "mia", image: ASSESTS.USERPROFILE, label: "Mia Clark", email: "mia.clark@email.com" }
                    ]} 
                />
                <FormTextArea
                    className={styles.textArea}
                    fieldTheme={IFieldTheme.LIGHT2}
                    label={'Promotional Script'}
                    placeholder='Enter a promotional script for this sponsored user...'
                />
                <FormCheckbox
                    label={'Send notification to all users about new sponsored user.'}
                    id='sendNotification'
                />
            </Modal.Body>
            <Modal.Footer bsPrefix={styles.footer}>
                <CustomButton
                    className={styles.addMoreBtn}
                    btnType={ButtonType.LIGHTBLUE}
                    btnRadius={ButtonRadiusSize.SMALL}
                    onClick={onClose}
                >
                    Cancel
                </CustomButton>
                <CustomButton
                    className={styles.addBtn}
                    btnType={ButtonType.GREEN}
                    btnRadius={ButtonRadiusSize.SMALL}
                >
                    Promote User
                </CustomButton>
            </Modal.Footer>
        </Modal>
    );
}

export default PromoteToSponsoredUser;